import React from "react"
import { AppText } from "~/ui/app-text"
import { UserAvatar } from "~/ui/user-avatar"
import chatCircleText from "~/images/chat-circle-text"
import { formatCount } from "~/common/number-utils"

interface User {
  avatarUrl?: string | null
  shortDisplayName?: string | null
}

interface MessageRepliesProps {
  childMessagesCount: number
  childMessageUsers: User[] | null | undefined
}

export const MessageReplies: React.FC<MessageRepliesProps> = ({
  childMessagesCount,
  childMessageUsers,
}) => {
  if (!childMessagesCount || !childMessageUsers || childMessageUsers.length === 0) {
    return null
  }

  return (
    <div className="border-white/56 flex h-8 items-center rounded-full border px-2 shadow-sm">
      <div className="flex">
        {childMessageUsers.slice(0, 2).map((user, userIndex) => {
          const userAvatarUrl = user?.avatarUrl || null
          const userDisplayName = user?.shortDisplayName || "User"

          return (
            <div
              key={userIndex}
              className={`h-5 w-5 overflow-hidden rounded-full ${userIndex !== 0 ? "-ml-1.5" : ""}`}
            >
              <UserAvatar avatarUrl={userAvatarUrl} displayName={userDisplayName} size="xsm" />
            </div>
          )
        })}
        <div className="relative -ml-1.5">
          <img src={chatCircleText.src} alt="Chat Bubble" className="h-5.25 w-5.25" />
        </div>
      </div>
      <AppText variant="body3-medium" className="ml-1 text-base-black">
        {formatCount(childMessagesCount)}
      </AppText>
    </div>
  )
}
